import React, { useState, useEffect } from 'react';
import { InputText } from 'primereact/inputtext';
import { ReactComponent as ValidationErrorIcon } from '../../assets/images/validation-error.svg';
import { classNames } from 'primereact/utils';

const InputAmount = ({
    showLabel = true,
    label,
    validator,
    validations,
    value,
    onChange,
    placeholder = "0,00",
    maxValue = 999999,
    showValidation = true,
    inputClassName,
    ...rest
}) => {
    const id = `amount-${rest.id}`;
    const validationMessage = validator && showValidation ? validator.message(id, label, value, validations) : null;

    const [displayValue, setDisplayValue] = useState('');

    // Synchronizuj displayValue z value
    useEffect(() => {
        if (value !== null && value !== undefined) {
            setDisplayValue(value.toFixed(2).replace('.', ','));
        } else {
            setDisplayValue('');
        }
    }, [value]);

    const handleChange = (e) => {
        const inputValue = e.target.value;
        // Pozwól na cyfry, jeden przecinek z maksymalnie 2 cyframi po nim i opcjonalny minus na początku
        if (inputValue === '' || /^-?[0-9]*[,]?[0-9]{0,2}$/.test(inputValue)) {
            setDisplayValue(inputValue);
        }
    };

    const handleBlur = (e) => {
        const inputValue = e.target.value;
        if (inputValue !== '') {
            const value = parseFloat(inputValue.replace(',', '.'));
            if (!isNaN(value)) {
                // Usuń ograniczenie do wartości nieujemnych - pozwól na wartości ujemne
                const limitedValue = Math.min(value, maxValue);
                if (onChange) {
                    onChange({ target: { value: limitedValue } });
                }
                setDisplayValue(limitedValue.toFixed(2).replace('.', ','));
            } else {
                setDisplayValue('');
                if (onChange) {
                    onChange({ target: { value: null } });
                }
            }
        } else {
            if (onChange) {
                onChange({ target: { value: null } });
            }
        }
    };

    return (
        <div className="field">
            {showLabel && <label htmlFor={id}>{label}</label>}
            <InputText
                {...rest}
                id={id}
                className={classNames(inputClassName || 'w-full', { 'p-invalid': validationMessage })}
                autoComplete='off'
                value={displayValue}
                placeholder={placeholder}
                onChange={handleChange}
                onBlur={handleBlur}
            />

            {validationMessage && <div className={"validation-error"}>
                <ValidationErrorIcon className='icon' />
                <div className="text">{validationMessage}</div>
            </div>}
        </div>
    );
};

export default InputAmount;
